import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGifts } from '../../redux/actions/pack';
import GeneralNotifModal from '../GeneralModal/generalNotifModal';
import { sendGift } from '../../redux/actions/liveShow';
import { Loading, TopupGuideline } from '..';

import styles from './SendGiftModal.module.css';

import diamondIcn from '../../assets/diamonds.svg';
import { getAccountInfo } from '../../redux/actions/auth';

const generateDataPagination = (data, itemPerPage) => {
  const newData = [];
  const totalPage = Math.ceil(data.length / itemPerPage);

  for (let pageIndex = 0; pageIndex < totalPage; pageIndex++) {
    newData.push(
      data.slice(pageIndex * itemPerPage, pageIndex * itemPerPage + itemPerPage)
    );
  }

  return {
    data: newData,
    totalPage,
  };
};

const SendGiftModal = ({ show, onShow, onClose, giftType }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const userDiamonds = user && user.account && user.account.diamonds;
  const { profileInfo } = useSelector((state) => state.publicProfile);
  const dataGifts = useSelector((state) => state.pack.giftOption);
  const maxItemPerPage = 8;
  const { data: dataGiftPagination } = useMemo(
    () => generateDataPagination(dataGifts, maxItemPerPage),
    [dataGifts]
  );
  const [giftPage, setGiftPage] = useState(1);
  const giftListRef = useRef();
  const [selectedGift, setSelectedGift] = useState();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [sendingGift, setSendingGift] = useState(false);
  const [showSendStatusModal, setShowSendStatusModal] = useState();
  const [showTopUpGuideline, setShowTopUpGuideline] = useState(false);

  useEffect(() => {
    dispatch(getGifts());
  }, [dispatch]);

  const handleGiftPage = (page, index) => {
    const gitListEl = giftListRef.current;
    const giftListPage = gitListEl.children;
    const slide = index * -100;

    giftListPage[0].style.marginLeft = slide + '%';

    setGiftPage(page);
  };

  const handleSelectGift = (itemPack) => {
    if (selectedGift && selectedGift.id === itemPack.id) {
      setSelectedGift();
    } else {
      setSelectedGift(itemPack);
    }
  };

  const handleConfirmSendDiamond = () => {
    if (userDiamonds && userDiamonds > parseInt(selectedGift.price)) {
      setShowConfirmDialog(true);
      onClose();
    } else {
      setShowTopUpGuideline(true);
    }
  };

  const handleSendGift = async () => {
    setSendingGift(true);

    try {
      await dispatch(
        sendGift({
          packId: selectedGift.id,
          receiverId: profileInfo?.profile.accountId,
          giftType,
        })
      );

      setShowSendStatusModal({
        status: 'success',
        title: 'Send Diamonds Successful',
        message: `You successfully sent ${
          selectedGift && parseInt(selectedGift.price).toFixed(0)
        } Diamonds to ${profileInfo?.profile.name}.`,
      });
    } catch (err) {
      setShowSendStatusModal({
        status: 'failed',
        title: 'Send Diamonds Failed',
        message: `Failed to send diamonds to ${profileInfo?.profile.name}. Please try again later`,
      });
    } finally {
      setSendingGift(false);
      setShowConfirmDialog(false);
    }
  };

  const handleCloseSendStatusModal = () => {
    if (showSendStatusModal && showSendStatusModal.status === 'success') {
      dispatch(getAccountInfo());
    }

    setShowSendStatusModal();
  };

  return (
    <GeneralNotifModal open={show} contentClass={styles.sendGiftModal}>
      <div className={styles.modalHeader}>
        Your Diamonds: <img src={diamondIcn} alt='diamonds' width={16} />{' '}
        {userDiamonds}
      </div>
      <div className={styles.giftList} ref={giftListRef}>
        {dataGiftPagination &&
          dataGiftPagination.map((gifts, i) => {
            return (
              <div className={styles.giftsPage} key={i}>
                {gifts.map((item) => {
                  const icon = item.icons.find((i) => i.type === 'static');
                  const itemPack = item.packs[0];
                  const isSelected =
                    itemPack.id === (selectedGift && selectedGift.id);

                  return (
                    <div
                      key={item.id}
                      className={styles.giftItem}
                      data-selected={isSelected}
                      onClick={() => handleSelectGift(itemPack)}
                    >
                      <img src={icon.url} alt={item.name} />
                      <span>{item.name}</span>
                      <span>
                        <img src={diamondIcn} alt='diamonds' width={16} />
                        {parseInt(itemPack.price).toFixed(0)}
                      </span>
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
      <div className={styles.giftListPagination}>
        {dataGiftPagination &&
          dataGiftPagination.map((_, index) => {
            return (
              <div
                key={index}
                className={styles.dot}
                data-page-indicator={
                  giftPage === index + 1 ? 'active' : 'inactive'
                }
                onClick={() => handleGiftPage(index + 1, index)}
              ></div>
            );
          })}
      </div>
      <div
        className={styles.actionButton}
        data-btn-status={selectedGift ? 'active' : 'inactive'}
        onClick={selectedGift ? handleConfirmSendDiamond : () => {}}
      >
        Send
      </div>
      <div className={styles.actionButton} onClick={onClose}>
        Cancel
      </div>

      <GeneralNotifModal
        open={showConfirmDialog}
        contentClass={styles.confirmModal}
      >
        {sendingGift ? (
          <>
            <Loading />
            <p>Sending Gift</p>
          </>
        ) : (
          <>
            <h3>Send Diamonds?</h3>
            <p>
              Are you sure to send{' '}
              {selectedGift && parseInt(selectedGift.price).toFixed(0)} Diamonds
              to {profileInfo?.profile.name}?
            </p>
            <div
              className={`${styles.actionButton} ${styles.confirmButton}`}
              onClick={handleSendGift}
            >
              Yes, Sure
            </div>
            <div
              className={styles.actionButton}
              onClick={() => {
                setShowConfirmDialog(false);
                onShow();
              }}
            >
              Cancel
            </div>
          </>
        )}
      </GeneralNotifModal>

      {showSendStatusModal && (
        <GeneralNotifModal
          open={showSendStatusModal}
          contentClass={styles.confirmModal}
        >
          <h3>{showSendStatusModal.title}</h3>
          <p>{showSendStatusModal.message}</p>
          {showSendStatusModal.status === 'success' && (
            <div className={styles.successAnimation}>
              <div className={styles.circleAnimation}></div>
              <svg viewBox='0 0 100 100'>
                <path d='m 2 43 l 37 35 l 55 -60'></path>
              </svg>
            </div>
          )}
          <div
            className={`${styles.actionButton} ${styles.primaryButton}`}
            onClick={handleCloseSendStatusModal}
          >
            {showSendStatusModal.status === 'success' ? 'Done' : 'OK'}
          </div>
        </GeneralNotifModal>
      )}

      <TopupGuideline
        open={showTopUpGuideline}
        dismiss={() => setShowTopUpGuideline(false)}
      >
        <h3 className={styles.topUpHeader}>Not enough diamonds</h3>
      </TopupGuideline>
    </GeneralNotifModal>
  );
};

export default SendGiftModal;
